import { __assign, __rest } from "tslib";
import React from 'react';
import InternalStatusIndicator from './internal';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import useBaseComponent from '../internal/hooks/use-base-component';
export default function StatusIndicator(_a) {
    var _b = _a.type, type = _b === void 0 ? 'success' : _b, props = __rest(_a, ["type"]);
    var baseComponentProps = useBaseComponent('StatusIndicator');
    return React.createElement(InternalStatusIndicator, __assign({ type: type }, props, baseComponentProps));
}
applyDisplayName(StatusIndicator, 'StatusIndicator');
//# sourceMappingURL=index.js.map